import { useShallow } from 'zustand/react/shallow'

import { Button } from '@ui/components/core'
import { Template } from '@ui/interfaces'
import { useLogoPathBySlug } from '@ui/lib/hooks/useLogoPathBySlug'
import { GetTemplates } from '@ui/loaders/templates'
import { useExporterNodeStore } from '@ui/stores'

interface ExporterTilesProps {
  cancel: () => void
}

export function ExporterTiles({ cancel }: ExporterTilesProps) {
  const { data, loading } = GetTemplates({ nodeType: 'EXPORT' })
  const templates = data?.getTemplates || []

  if (loading) {
    return <div>Loading...</div>
  } else {
    return (
      <div className="relative h-full w-full rounded-md bg-white p-6">
        <div className="grid grid-cols-2 gap-2">
          {templates.map((template) => {
            return <Tile key={template.slug} template={template as unknown as Template} />
          })}
        </div>
        <div className="absolute right-0 mb-4 mr-6">
          <Button loading={false} onClick={cancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }
}

function Tile({ template }: { template: Template }) {
  const setTemplate = useExporterNodeStore(useShallow((state) => state.setTemplate))
  const setWizardStep = useExporterNodeStore(useShallow((state) => state.setWizardStep))

  const onClick = () => {
    setTemplate(template)
    setWizardStep(1)
  }
  const logoPathBySlug = useLogoPathBySlug([template.slug])

  return (
    <div
      data-testid={template.slug}
      className="ring-white/6 w-full rounded-lg text-sm font-medium leading-5 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2">
      <div
        onClick={onClick}
        className="border-1 group relative flex items-center gap-x-6 rounded-lg border bg-white p-4 text-sm leading-6 duration-100 ease-in hover:cursor-pointer hover:border-primary-600 hover:bg-primary-50">
        <div className="flex h-11 w-11 flex-none items-center justify-center ">
          <img
            src={logoPathBySlug[template.slug]}
            className="h-full w-full text-gray-600 group-hover:text-blue-700"
            aria-hidden="true"
          />
        </div>
        <div className="flex-auto">
          <p className="block font-semibold">
            {template.name}
            <span className="absolute inset-0" />
          </p>
          <p className="text-gray-600">{template.description}</p>
        </div>
      </div>
    </div>
  )
}
